import { ObjectAnyType } from '@/types/generic'

export function objectKeysOnlyStrings (object: ObjectAnyType) {
    const result: ObjectAnyType = {}

    for (const key in object) {
        if (typeof object[key] === 'string') {
            result[key] = object[key]
        }
    }

    return result
}

export function isObject (value: any) {
    return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function isEmpty (value: any) {
    return value === '' || value == null
}

export function parseJsonStringOrReturnString (jsonString: string): string | ObjectAnyType {
    try {
        const parsedData = JSON.parse(jsonString)
        if (Array.isArray(parsedData) || typeof parsedData === 'object') {
            return parsedData
        } else {
            return jsonString
        }
    } catch (error) {
        return jsonString
    }
}
